import { useForm } from '@tanstack/react-form'
import { getCurrentUserRoleInfo } from '#shared/lib/auth'
import { UseFormOptions } from '#shared/model'
import PreregisterFormValue from '../model/preregister-form-value'

export default function usePreregisterForm({ onSubmit }: UseFormOptions<PreregisterFormValue>) {
  const roleInfo = getCurrentUserRoleInfo()

  const validateAgreements = (value: PreregisterFormValue) => {
    if (!value.isAgreedWithPrivacyPolicyAndToS) {
      return 'Вы должны согласиться с условиями использования'
    }

    if (roleInfo.role === 'client' && !value.isAgreedWithTermsOfContract) {
      return 'Вы должны согласиться с учловиями договора'
    }
  }

  return useForm<PreregisterFormValue>({
    defaultValues: {
      username: Telegram.WebApp.initDataUnsafe.user?.username ?? '',
      email: '',
      isAgreedWithPrivacyPolicyAndToS: false,
      isAgreedWithTermsOfContract: false,
    },

    defaultState: {
      isValid: false,
    },

    validators: {
      onMount: ({ value }) => validateAgreements(value),

      onChange: ({ value }) => validateAgreements(value),
    },

    onSubmit: ({ value }) => onSubmit?.(value),
  })
}
